import { useContext } from "react";
import DisableContext from "../contexts/disable-context";

export const useDisable = () => useContext(DisableContext);
